// Ajax请求封装，仅包含get和post方法
class RequestUtil {
  constructor() {
    this.baseURL = 'https://program.api.beijingxibao.com';
        // this.baseURL = 'http://127.0.0.1:9527';

    this.timeout = 10000; // 默认超时时间10秒
    this.defaultHeaders = {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    };
    this.loadingInstance = null;
    
    // OBS配置
    this.obsConfig = {
      proxyEndpoint: '/api/proxy/obs', // 服务端代理接口
      allowedDomains: ['obs.cn-north-4.myhuaweicloud.com', 'your-bucket.obs.cn-north-4.myhuaweicloud.com']
    };
  }

  // 判断是否为OBS URL
  isObsUrl(url) {
    return url.includes('myhuaweicloud.com') || url.includes('obs.') || url.includes('huawei') || url.includes('hwccdc');
  }
  
  // 通过服务端代理获取OBS文件
  async getObsFile(obsUrl) {
    try {
      const proxyResponse = await fetch(`${this.baseURL}${this.obsConfig.proxyEndpoint}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          url: obsUrl,
          method: 'GET'
        })
      });
      
      if (!proxyResponse.ok) {
        throw new Error(`代理请求失败: ${proxyResponse.status}`);
      }
      
      // 返回文件内容或文件流
      const contentType = proxyResponse.headers.get('content-type');
      if (contentType && contentType.includes('application/json')) {
        return await proxyResponse.json();
      } else {
        // 对于PDF等二进制文件，返回blob
        const blob = await proxyResponse.blob();
        return URL.createObjectURL(blob);
      }
    } catch (error) {
      console.error('OBS文件获取失败:', error);
      throw error;
    }
  }
  
  // 显示加载动画
  showLoading() {
    // 检查是否已有加载实例
    if (this.loadingInstance) {
      return;
    }
    
    // 创建加载遮罩层
    const loadingOverlay = document.createElement('div');
    loadingOverlay.style.position = 'fixed';
    loadingOverlay.style.top = '0';
    loadingOverlay.style.left = '0';
    loadingOverlay.style.width = '100%';
    loadingOverlay.style.height = '100%';
    loadingOverlay.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
    loadingOverlay.style.display = 'flex';
    loadingOverlay.style.justifyContent = 'center';
    loadingOverlay.style.alignItems = 'center';
    loadingOverlay.style.zIndex = '9999';
    loadingOverlay.style.backdropFilter = 'blur(2px)';
    
    // 创建加载容器
    const loaderContainer = document.createElement('div');
    loaderContainer.style.position = 'relative';
    loaderContainer.style.width = '80px';
    loaderContainer.style.height = '80px';
    
    // 创建加载指示器
    const loader = document.createElement('div');
    loader.style.border = '5px solid #f3f3f3';
    loader.style.borderTop = '5px solid #3498db';
    loader.style.borderRadius = '50%';
    loader.style.width = '80px';
    loader.style.height = '80px';
    loader.style.animation = 'spin 1s linear infinite';
    
    // 创建logo元素
    const logoElement = document.createElement('img');
    logoElement.src = '/images/product/logo.png';
    logoElement.alt = '西宝';
    logoElement.style.position = 'absolute';
    logoElement.style.top = '50%';
    logoElement.style.left = '50%';
    logoElement.style.transform = 'translate(-50%, -50%)';
    logoElement.style.maxWidth = '40px';
    logoElement.style.maxHeight = '40px';
    logoElement.style.objectFit = 'contain';
    
    // 添加旋转动画样式
    const styleSheet = document.createElement('style');
    styleSheet.textContent = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(styleSheet);
    
    loaderContainer.appendChild(loader);
    loaderContainer.appendChild(logoElement);
    loadingOverlay.appendChild(loaderContainer);
    document.body.appendChild(loadingOverlay);
    
    this.loadingInstance = loadingOverlay;
  }
  
  // 隐藏加载动画
  hideLoading() {
    if (this.loadingInstance) {
      document.body.removeChild(this.loadingInstance);
      this.loadingInstance = null;
      
      // 移除动画样式（如果不再需要）
      const styles = document.getElementsByTagName('style');
      for (let i = 0; i < styles.length; i++) {
        if (styles[i].textContent.includes('@keyframes spin')) {
          document.head.removeChild(styles[i]);
          break;
        }
      }
    }
  }

  // GET请求
  async get(url, params = {}) {
    this.showLoading();
    
    // 检查是否为OBS文件URL
    if (this.isObsUrl(url)) {
      return await this.getObsFile(url);
    }
    
    let queryString = '';
    if (params && Object.keys(params).length > 0) {
      queryString = '?' + Object.keys(params).map(key => 
        encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
      ).join('&');
    }
    
    const fullUrl = this.baseURL + url + queryString;
    
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), this.timeout);

    try {
      const response = await fetch(fullUrl, {
        method: 'GET',
        headers: this.defaultHeaders,
        signal: controller.signal
      });

      clearTimeout(timeoutId);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      clearTimeout(timeoutId);
      if (error.name === 'AbortError') {
        throw new Error('请求超时');
      }
      console.error('GET请求失败:', error);
      throw error;
    } finally {
      this.hideLoading();
    }
  }

  // POST请求
  async post(url, data = {}) {
    this.showLoading();
    const fullUrl = this.baseURL + url;
    
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), this.timeout);

    try {
      const response = await fetch(fullUrl, {
        method: 'POST',
        headers: this.defaultHeaders,
        body: JSON.stringify(data),
        signal: controller.signal
      });

      clearTimeout(timeoutId);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      clearTimeout(timeoutId);
      if (error.name === 'AbortError') {
        throw new Error('请求超时');
      }
      console.error('POST请求失败:', error);
      throw error;
    } finally {
      this.hideLoading();
    }
  }
}

// 创建实例并导出
const requestUtil = new RequestUtil();
export default requestUtil;